import { useSnackbar } from 'notistack';

const useEnqueueStacks = () => {
  const { enqueueSnackbar } = useSnackbar();

  const enqueueDefault = (message, options) => enqueueSnackbar(message, { variant: 'default', ...options });

  const enqueueError = (message, options) => enqueueSnackbar(message, { variant: 'error', ...options });

  const enqueueSuccess = (message, options) => enqueueSnackbar(message, { variant: 'success', ...options });

  const enqueueWarning = (message, options) => enqueueSnackbar(message, { variant: 'warning', ...options });

  const enqueueInfo = (message, options) => enqueueSnackbar(message, { variant: 'info', ...options });

  return {
    enqueueDefault,
    enqueueError,
    enqueueSuccess,
    enqueueWarning,
    enqueueInfo,
  };
};

export { useEnqueueStacks };
